import { ValidatorFn, Validators } from '@angular/forms';
import { UserRoleEnum } from '@enums/user-role.enum';

/** The text that explains why the IB repo needs verification, by reason. */
export const IB_REPO_REASON_TEXTS: Readonly<Record<string, string>> = {
  NoDeparture: 'Inbound reposition was not captured within the tracking window; hours shown are an estimate.',
  AirportMismatch: 'Aircraft landed at a different airport than planned.',
  IncompleteCapture: 'Landing was captured without a departure time.',
};

/** The maximum verified hours. The backend validator uses the same value. */
export const IB_REPO_MAX_VERIFIED_HOURS = 99.99;

/** The validators of the verified hours: required, 0 to 99.99, maximum 2 decimals. */
export const IB_REPO_VERIFIED_HOURS_VALIDATORS: readonly ValidatorFn[] = [
  Validators.required,
  Validators.min(0),
  Validators.max(IB_REPO_MAX_VERIFIED_HOURS),
  Validators.pattern(/^\d{1,2}(\.\d{1,2})?$/),
];

/** The maximum length of the verification note. */
export const IB_REPO_NOTE_MAX_LENGTH = 500;

/** The roles that can verify the IB repo hours. */
export const IB_REPO_VERIFY_ROLES: readonly string[] = [UserRoleEnum.ACCOUNTING, UserRoleEnum.MANAGEMENT, UserRoleEnum.EXECUTIVE_ADMIN];
